import { render, staticRenderFns } from "./genres.vue?vue&type=template&id=15ffaac0&scoped=true"
import script from "./genres.vue?vue&type=script&setup=true&lang=js"
export * from "./genres.vue?vue&type=script&setup=true&lang=js"
import style0 from "./genres.vue?vue&type=style&index=0&id=15ffaac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ffaac0",
  null
  
)

export default component.exports